import * as pathToRegExp from 'path-to-regexp';

export { pathToRegExp };
